<template>
  <div>
    <h2 class="mt-1 ml-15 hidden-sm-and-down grey--text">Credito Cobranza</h2> <!-- Full Screen -->
    <h3 class="mt-1 hidden-sm-and-up grey--text">Credito Cobranza</h3> <!-- Mobile Screen -->
    <div class="mt-5">
      <v-bottom-navigation :value="value" color="success">
        <v-btn @click="OpenComponent(0)" :disabled="comp0">
          <span>Pago Cliente</span>
          <v-icon>{{PagoIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(1)" :disabled="comp1">
          <span>Pago Proveedor</span>
          <v-icon>{{CobroIcon}}</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <div v-if="CreditoCobranza=='V'" class="mt-2">
      
          <component v-bind:is="componente" :usu="usu" :contrato="contrato"></component>
      
      </div>
      <div v-if="CreditoCobranza=='N'">
        <v-row class="mt-15">
          <v-col cols="1" md="4"></v-col>
          <v-col cols="10" md="4">
            <v-card rounded="xl">
              <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <span class="text-body-2">
                            Este módulo no está incluido en tu plan actual.
                            <br><br>
                            Puedes activarlo en cualquier momento como un complemento independiente, sin necesidad de cambiar de plan
                            <br><br>
                            Comunicate con soporte o visita nuestro sitio Web
                            <br>
                            <a target="_blank" href="https://www.bodeganet.cl">www.bodeganet.cl</a>
                        </span>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="1" md="4"></v-col>
        </v-row>
      </div>

    </div>
    <dialogo :loading="loading"  />
  </div>
</template>

<script>
import axios from 'axios';
import dialogo from '@/components/dialogo.vue';
import PagoCliente from '@/components/PagoCliente.vue';
import PagoProveedor from '@/components/PagoProveedor.vue';
export default {
  name: 'Credito',
  components: { dialogo, PagoCliente, PagoProveedor },
  props: ['usu','contrato'],
  data(){
    return{
      loading:false,
      value:null,
      componente:'',
      IconSelect:'check_circle',
      PagoIcon:'monetization_on',
      CobroIcon:'monetization_on',
      IconDefault:'monetization_on',
      comp0:true,
      comp1:true,
      CreditoCobranza:'',
    }
  },
  async mounted(){
    const auth = await this.AuthModules();
    if(auth=='V'){
      await this.entrada();
    }
  },
   methods:{
    async AuthModules(){
      let result = 'N'
        try {
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/autoriza_modulos/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    const key = element.Modulo;
                    if(key == "Credito Cobranza"){
                        result = element.Estado;
                        this.CreditoCobranza = element.Estado
                    }
                });
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async entrada(){
      this.loading=true;
      const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+ this.contrato +'/'+ this.usu);
      const datos=response.data;
      if (datos[0].existe=='si'){
        if(datos[0].Permiso_8_1!=0) {
          this.comp0=false;
        };
        if(datos[0].Permiso_8_2!=0) {
          this.comp1=false;
        };
      } 
      this.moduloActivo();      
    },
    moduloActivo(){
        if (this.comp0!=true){
            this.componente='PagoCliente';
            this.PagoIcon=this.IconSelect;
            this.CobroIcon=this.IconDefault;
            this.value=0
        } else {
            if (this.comp1!=true){
                this.componente='PagoProveedor';
                this.PagoIcon=this.IconDefault;
                this.CobroIcon=this.IconSelect;
                this.value=1
            } else {
                this.PagoIcon=this.IconDefault;
                this.CobroIcon=this.IconDefault;
            }
        }
        this.loading=false;
    },
    OpenComponent(value){
      let vComponente;
      switch (value) {
        case 0:
          vComponente='PagoCliente';
          this.PagoIcon=this.IconSelect;
          this.CobroIcon=this.IconDefault;
        break;
        case 1:
          vComponente='PagoProveedor';
          this.PagoIcon=this.IconDefault;
          this.CobroIcon=this.IconSelect;
        break;
      }
      this.componente=vComponente;
    }
  }
}
</script>